import { Directive, ElementRef, inject, input } from '@angular/core';

@Directive({
  selector: '[appClickable]',
  host: {
    '[attr.role]': 'role()',
    '[attr.tabindex]': 'appClickableDisabled() ? null : 0',
    '[attr.aria-disabled]': 'appClickableDisabled() ? true : null',
    '(keydown)': 'onKeydown($event)',
  },
})
export class ClickableDirective {
  element = inject<ElementRef<HTMLElement>>(ElementRef);

  role = input('button');
  appClickableDisabled = input(false);

  onKeydown = (event: KeyboardEvent) => {
    if (event.target !== this.element.nativeElement) {
      return;
    }

    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    if (this.appClickableDisabled()) {
      return;
    }

    event.preventDefault();
    this.element.nativeElement.click();
  };
}
